(function() {
  'use strict';

  // How long to wait for the Amplitude SDK (ms)
  var MAX_WAIT = 5000;
  var POLL_INTERVAL = 50;

  function waitForAmplitude(callback) {
    var elapsed = 0;
    var check = setInterval(function() {
      elapsed += POLL_INTERVAL;
      if (window.amplitude && window.Experiment && amplitude.getDeviceId()) {
        clearInterval(check);
        callback();
      } else if (elapsed >= MAX_WAIT) {
        clearInterval(check);
        // Amplitude didn't load — show all control sections as fallback
        showFallback();
      }
    }, POLL_INTERVAL);
  }

  function dismissLoader() {
    var bar = document.getElementById('ab-loader-bar');
    var loader = document.getElementById('ab-loader');
    if (bar) bar.style.width = '100%';
    if (loader) {
      setTimeout(function() {
        loader.classList.add('ab-loader--hidden');
        setTimeout(function() { loader.remove(); }, 350);
      }, 200);
    }
  }

  function showFallback() {
    var sections = document.querySelectorAll('[data-ab-variant="control"]');
    sections.forEach(function(el) {
      el.style.display = '';
    });
    dismissLoader();
  }

  function run() {
    // Find all AB test sections on this page
    var allSections = document.querySelectorAll('[data-ab-flag]');
    if (allSections.length === 0) return;

    // Collect unique experiment flag keys
    var flags = {};
    allSections.forEach(function(el) {
      flags[el.getAttribute('data-ab-flag')] = true;
    });
    var flagKeys = Object.keys(flags);

    // Initialise Experiment SDK and manually pass Amplitude user identity
    var experiment = Experiment.initialize(
      window.AB_TEST_DEPLOYMENT_KEY,
      { instanceName: 'ab-test', serverUrl: 'https://api.lab.eu.amplitude.com' }
    );
    var deviceId = amplitude.getDeviceId();
    var userId = amplitude.getUserId() || undefined;

    // Fetch all flag evaluations for this user
    experiment.fetch({ device_id: deviceId, user_id: userId }).then(function() {
      // Remove blocking CSS injected by the cache-resolve script so inline styles take over
      var resolveStyle = document.getElementById('ab-test-resolve');
      if (resolveStyle) resolveStyle.remove();

      var cached = {};
      flagKeys.forEach(function(flagKey) {
        var variant = experiment.variant(flagKey);
        var assignedVariant = (variant && variant.value) ? variant.value : 'control';
        cached[flagKey] = assignedVariant;

        // Track exposure so Amplitude Experiments tab counts this user as a participant
        amplitude.track('$exposure', { flag_key: flagKey, variant: assignedVariant });

        // Show matching variant, hide others (supports above-fold sections that start visible)
        var allForFlag = document.querySelectorAll('[data-ab-flag="' + flagKey + '"]');
        allForFlag.forEach(function(el) {
          if (el.getAttribute('data-ab-variant') === assignedVariant) {
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      });

      // Cache assignments so the blocking resolve script can prevent flicker on next visit
      try { localStorage.setItem('ab_variants', JSON.stringify(cached)); } catch(e) {}

      dismissLoader();
    }).catch(function() {
      // On error, fall back to showing control
      showFallback();
    });
  }

  waitForAmplitude(run);
})();
